'use client';

import React, { ReactNode, useState, useEffect } from 'react';

import styles from './TabComponent.module.scss';

interface TabItem {
  key: string;
  label: ReactNode;
  disabled?: boolean;
  content: ReactNode;
}

interface TabsProps {
  items: TabItem[];
  defaultKey?: string;
  className?: string;
  onChange?: (key: string) => void;
}

const CarbonTabs: React.FC<TabsProps> = ({ items, defaultKey, className, onChange }) => {
  const firstEnabled = items.find(it => !it.disabled)?.key;
  const [activeKey, setActiveKey] = useState<string>(defaultKey ?? firstEnabled ?? items?.[0]?.key);

  useEffect(() => {
    if (defaultKey) {
      setActiveKey(defaultKey);
    }
  }, [defaultKey]);

  const handleChange = (key: string) => {
    const tab = items.find(t => t.key === key);
    if (!tab?.disabled) {
      setActiveKey(key);
      onChange?.(key);
    }
  };

  return (
    <div className={className}>
      {/* Desktop tab headers */}
      <div role="tablist" className={styles.tabsHeader}>
        {items.map(tab => {
          const tabClass = [
            styles.tabButton,
            activeKey === tab.key && styles.active,
            tab.disabled && styles.disabled,
          ]
            .filter(Boolean)
            .join(' ');

          return (
            <button
              key={tab.key}
              role="tab"
              onClick={() => handleChange(tab.key)}
              disabled={tab.disabled}
              aria-selected={activeKey === tab.key}
              className={tabClass}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab panels */}

      <div className={styles.tabsPanels}>
        {items.map(tab => {
          if (activeKey === tab.key)
            return (
              <div
                key={tab.key}
                role="tabpanel"
                aria-labelledby={tab.key}
                // hidden={activeKey !== tab.key}
                className={styles.tabPanel}
              >
                {tab.content}
              </div>
            );
        })}
      </div>
    </div>
  );
};
export default CarbonTabs;
